<main>
  <h1 class="pr-large-t font-heading-1">{{ 'MMB.checkIn.confirmation.title' | finLocalization }}</h1>

  <p class="pr-small-y nordic-blue-900-text">
    {{ 'MMB.checkIn.funnel.confirmation.description' | finLocalization }}
  </p>

  <fcom-button
    data-testid="check-in-feedback-button"
    [text]="'MMB.purchase.success.feedback.button' | finLocalization"
    (clickBtn)="openModal($event)"
  />

  <fin-qualtrics [survey]="survey" [(open)]="openSurvey" />

  <div class="mr-medium-y ps-medium border rounded-large nordic-blue-100-border white-bg">
    <div class="flex">
      <fcom-icon class="icon-medium nordic-blue-900-text mr-xsmall-r" [name]="SvgLibraryIcon.CHECKMARK_BLOCK" />
      <div>
        <span class="font-body-1">
          {{ 'MMB.checkIn.funnel.steps.confirmation.boardingPassSentMessage' | finLocalization }}</span
        >
        <div class="flex flex--column" data-hj-suppress>
          <span class="font-body-1 bold-type" *ngFor="let email of uniquePassengerEmails$ | async">
            {{ email }}
          </span>
        </div>
        <button data-testid="show-email-modal-button" class="ps-small-y" (click)="showSendEmailModal$.next(true)">
          <span class="flex font-body-1 view-details-info">
            <span class="underline bold-type">{{
              'MMB.checkIn.funnel.confirmation.email.sendAnotherEmail' | finLocalization
            }}</span>
          </span>
        </button>
      </div>
    </div>
  </div>
  @if ((isVoluntaryDeniedBoarding$ | async) === true) {
    <fcom-notification [theme]="NotificationTheme.INFO" [iconName]="SvgLibraryIcon.DEPARTURE_GATE" class="ms-xlarge-b">
      <div class="flex flex--column">
        <span class="font-body-1 bold-type ms-xsmall-b">
          {{ 'MMB.checkIn.funnel.steps.confirmation.voluntaryDeniedBoarding.title' | finLocalization }}
        </span>
        <span class="font-body-1 ms-large-b">
          {{ 'MMB.checkIn.funnel.steps.confirmation.voluntaryDeniedBoarding.detail' | finLocalization }}
        </span>
        <div
          class="font-body-1 regular-type"
          [innerHTML]="
            'MMB.checkIn.funnel.steps.confirmation.voluntaryDeniedBoarding.changeYourMind'
              | finLocalization
              | finSafe: 'html'
          "
        ></div>
      </div>
    </fcom-notification>
  }

  <fin-check-in-boarding-pass-status
    [order$]="order$"
    [bound$]="bound$"
    [passengerIds$]="passengerIds$"
    [isCarrierConnect]="isCarrierConnect$ | async"
    [boardingPassIncludedServicesRequest$]="boardingPassIncludedServicesRequest$"
  />

  @if ('MMB.checkIn.confirmation.links.passengerRights.url' | finHasLocalizationKey) {
    <div class="pr-medium-t font-body-1 bold-type">
      <cms-unstyled-fragment
        [contentUrl$]="'MMB.checkIn.confirmation.links.passengerRights.url' | finLocalization | finToObservable"
      />
    </div>
  }

  @if (showCarTrawlerWidget$ | async) {
    <fin-cartrawler-widget class="mr-medium-t block" [order]="order$ | async" [clientId]="carTrawlerClientId" />
  }

  @if (showTravelInsuranceBanner$ | async) {
    <fin-ancillary-cta-banner
      [title]="'MMB.allianz.checkInBanner.title' | finLocalization"
      [mainText]="'MMB.allianz.checkInBanner.mainText' | finLocalization"
      [buttonText]="'MMB.allianz.checkInBanner.buttonText' | finLocalization"
      [href]="'MMB.allianz.checkInBanner.href' | finLocalization"
      [customIconForLogo]="CustomIcon.ALLIANZ_LOGO"
      [imageData]="allianz24HourBannerImage$ | async"
      class="mr-medium-t block"
    />
  }

  <fcom-cta-button
    [title]="'MMB.checkIn.confirmation.backToMmb' | finLocalization"
    [position]="ButtonPosition.GRID_FULL"
    [layout]="ButtonLayout.COLUMN"
    (buttonClicked)="redirectToMmb()"
  />
</main>

@if (showSendEmailModal$ | async) {
  <fcom-modal
    data-testid="send-email-modal"
    [fitToContent]="true"
    [forceRemainOpen]="emailSendingInProgress$ | async"
    [open]="true"
    [title]="'MMB.checkIn.funnel.confirmation.email.sendTitle' | finLocalization"
    [buttons]="ModalButtons.CUSTOM"
    [confirmEnabled]="true"
    (close)="showSendEmailModal$.next(false)"
  >
    <div class="ps-medium-y pr-large-x">
      <span class="font-body-1 pr-small-y">{{
        'MMB.checkIn.funnel.confirmation.email.sendMessage' | finLocalization
      }}</span>
      <fcom-text-input
        data-testid="email-input"
        class="block ms-small-t"
        [parentForm]="emailForm"
        [displayMargin]="false"
        [translationPrefix]="'paxDetails.fields.email'"
        [controlName]="'email'"
        [id]="'email'"
        [placeHolder]="'paxDetails.fields.email.placeholder'"
        [displayMargin]="false"
        [inputType]="InputType.EMAIL"
      />
    </div>
    <div buttons>
      <div class="align-center send-buttons">
        <fcom-button
          class="ps-small"
          [mode]="ButtonMode.FILL_MOBILE"
          [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
          [text]="'Close'"
          (clickBtn)="showSendEmailModal$.next(false)"
        />
        <fcom-button
          data-testid="send-email-button"
          class="ps-small"
          [type]="ButtonType.SUBMIT"
          [mode]="ButtonMode.FILL_MOBILE"
          [aria]="{
            disabled: !emailForm.valid || (emailSendingInProgress$ | async) === true,
            loadingLabel: 'actions.loading' | finLocalization,
          }"
          [loading]="(emailSendingInProgress$ | async) === true"
          [text]="'MMB.checkIn.confirmation.email.send' | finLocalization"
          (clickBtn)="sendEmail()"
        />
      </div>
    </div>
  </fcom-modal>
}
